import { render, staticRenderFns } from "./VideosSlideCreate.vue?vue&type=template&id=7e5bf4ca&scoped=true"
import script from "./VideosSlideCreate.vue?vue&type=script&lang=js"
export * from "./VideosSlideCreate.vue?vue&type=script&lang=js"
import style0 from "./VideosSlideCreate.vue?vue&type=style&index=0&id=7e5bf4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5bf4ca",
  null
  
)

export default component.exports